module.exports = "<div class=row> <div class=col-xs-12> <div class=form-group> <app-widgets-label label=$ctrl.teaserTitleLabel i18n-help=\"Teaser Title Help\"></app-widgets-label> <app-i18n-input field=route.teaser_title main-lang=route.main_lang></app-i18n-input> </div> </div> </div> <div class=row> <div class=col-xs-12> <div class=form-group> <app-widgets-label label=$ctrl.teaserLabel i18n-help=\"Teaser Help\"></app-widgets-label> <app-i18n-textarea field=route.teaser main-lang=route.main_lang></app-i18n-textarea> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/route/edit/general/partial_snowshoe_tour.html
// module id = 472
// module chunks = 0